import { Block, Carousel } from '@xprog/prensa'
import chunk from 'lodash/chunk'
import map from 'lodash/map'

const ColumnistSideBoxWidgetWrapper = ({ data }) => {
  const groupItems = chunk(data, 3)
  return (
    <Carousel
      axis='horizontal'
      css={{
        carousel: {
          width: '100%'
        },
        container: {
          width: '100%'
        },
        root: {
          width: '100%',
        },
        controlDots: {
          mt: '$2',
          mb: '$0',
        },
        controlDotsDot: {
          background: '#c4c4c4',
          boxShadow: 'none',
          height: '8px',
          width: '8px',
          opacity: '1',
          '&.selected': { background: 'black' }
        }
      }}
      labels={{
        item: '',
        leftArrow: 'Retroceder',
        rightArrow: 'Avançar'
      }}
      showArrows={false}
    >
      {map(groupItems, (items: any, key: number) => (
        <Block
          css={{ align: ['column', 'left', 'top'], width: 'auto' }}
          key={key}
        >
          {map(items, (item: any, key: number) => {
            return (
              <Block
                css={{ align: ['row', 'center', 'top'], width: 'auto' }}
                key={key}
              >
                {item}
              </Block>
            )
          })}
        </Block>
      ))}
    </Carousel>
  )
}

export default ColumnistSideBoxWidgetWrapper